import React, { useEffect, useRef, useState } from "react";
import Assistant from "../assistant/Assistant";
import SwotCard from "./SwotCard";
import styled, { css } from "styled-components";
import {
  IS_COPILOT,
  IS_HEAD,
  IS_PILOT,
  IS_SPONSOR,
  IS_SUPER_HEAD,
} from "../../permissions/roleTypes";
import { useSelector } from "react-redux";
import AddButton from "../buttons/AddButton";
import TextAreaCard from "./TextAreaCard";

const SwotColumn = ({
  name,
  items,
  type,
  icon,
  id,
  entity,
  entityName,
  entityComment,
  fromCoach,
  adjust
}) => {
  const [canBeEdited, setCanBeEdited] = useState(false);
  const currentUser = useSelector((state) => state.currentUser);
  const { sponsor } = useSelector((state) => state.oneAxis);
  const { pilot, copilot } = useSelector((state) => state.project);
  const [isAddCardOpen, setAddCardOpen] = useState(false);
  const [newDefaultValue, setNewDefaultValue] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    if (
      IS_SUPER_HEAD(currentUser.roles) ||
      IS_SPONSOR(currentUser.id, sponsor)
    ) {
      setCanBeEdited(true);
      return;
    }
    if (entity === "project") {
      if (
        IS_HEAD(currentUser.roles) ||
        IS_PILOT(currentUser.id, pilot.id) ||
        IS_COPILOT(currentUser.id, copilot)
      ) {
        setCanBeEdited(true);
      }
    }
  }, [
    copilot,
    currentUser,
    currentUser.id,
    currentUser.roles,
    entity,
    pilot.id,
    sponsor,
  ]);

  const displayType = () => {
    if (type === "strength") {
      return "force";
    }

    if (type === "weakness") {
      return "faiblesse";
    }

    if (type === "threat") {
      return "menace";
    }

    if (type === "opportunity") {
      return "opportunité";
    }
  };

  return (
    <Column $mode={id} ref={ref}>
      <Title>
        <img src={icon} alt={`icone de ${name}`} />
        <h2> {name} </h2>
        {entity !== "strategy" &&  (
          <AddButton
            setAddCart={() => {
              setNewDefaultValue("");
              setAddCardOpen(true);
            }}
          />
        )}
        {entity !== "strategy" &&(
          <Assistant
            context={{
              object: "swot",
              type: displayType(),
              entity,
              entityName,
              comment: entityComment,
            }}
            size={"small"}
            onSelect={(item) => {
              setNewDefaultValue(item.name + ": " + item.description);
              setAddCardOpen(true);
            }}
            swotCoach={fromCoach}
            adjust={adjust}
          />
        )}
      </Title>
      <Wrapper>
        {items.length > 0 ? (
          items.map((c) => (
            <SwotCard
              key={c.id}
              id={c.id}
              type={c.type}
              content={c.content}
              entity={entity}
              canBeEdited={canBeEdited}
              fromCoach={fromCoach}
            />
          ))
        ) : (
          <p> Aucune {displayType()} définie </p>
        )}
        {isAddCardOpen && canBeEdited && entity !== "strategy" && (
          <TextAreaCard
            content={newDefaultValue}
            type={type}
            entity={entity}
            setFormOpen={setAddCardOpen}
          />
        )}
      </Wrapper>
    </Column>
  );
};

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--color-grey-03);
  padding: 1rem;
  border-radius: 15px;
  width: 100%;
  margin: 0.5em;
  gap: 1rem;
  overflow: auto;
  ${(props) => {
    switch (props.$mode) {
      case 1:
        return css`
          grid-column-start: 2;
          grid-column-end: 7;
          grid-row-start: 1;
          grid-row-end: 3;
        `;
      case 2:
        return css`
          grid-column-start: 7;
          grid-column-end: 12;
          grid-row-start: 1;
          grid-row-end: 3;
        `;
      case 3:
        return css`
          grid-column-start: 2;
          grid-column-end: 7;
          grid-row-start: 3;
          grid-row-end: 5;
        `;
      case 4:
        return css`
          grid-column-start: 7;
          grid-column-end: 12;
          grid-row-start: 3;
          grid-row-end: 5;
        `;
      default:
        return css`
          position: absolute;
          margin: auto;
        `;
    }
  }}
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 0.5em;
`;

export default SwotColumn;
